// 2023/4/6 theme.js
export default {
  themeCyanColor: '#59D8C6',
  themeWhiteColor: '#fff',
  themeOrangeColor: '#FF9234',
  themeGreenColor: '#35D0BA',
}



// WEBPACK FOOTER //
// ./src/config/theme.js